import React, { useEffect, useState } from 'react';
import logo from '../../images/logo.png';
import baseURL from '../url';
import './StoreSidebar.css';
import { Link as Anchor } from 'react-router-dom';
import ShareWeb from '../ShareWeb/ShareWeb';

export default function StoreSidebar() {
    const [tienda, setTienda] = useState([]);
    const [images, setImages] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetch(`${baseURL}/tiendaGet.php`)
            .then(response => response.json())
            .then(data => setTienda(data?.tienda?.reverse()[0] || []))
            .catch(error => console.error('Error al cargar datos:', error));

        fetch(`${baseURL}/bannersGet.php`)
            .then(response => response.json())
            .then(data => {
                const bannersSeleccionados = Array.isArray(data.banner)
                    ? data.banner.filter(banner => banner.seleccion === 'Si')
                    : [];
                setImages(bannersSeleccionados.map(banner => banner.imagen));
                setLoading(false);
            })
            .catch(error => {
                console.error('Error al cargar productos:', error);
                setLoading(false);
            });
    }, []);

    return (
        <aside className="store-sidebar">
            {loading ? (
                <div className="sidebar-loading-banner" />
            ) : (
                images.length > 0 && (
                    <div className="sidebar-banner">
                        <img src={images[0]} alt="Banner" />
                    </div>
                )
            )}

            <div className="sidebar-profile">
                {tienda?.imagen1 ? (
                    <img src={tienda.imagen1} alt="logo" className="sidebar-logo" />
                ) : (
                    <img src={logo} alt="logo" className="sidebar-logo" />
                )}

                {tienda?.nombre && <h2>{tienda.nombre}</h2>}

                <div className="sidebar-info">
                    {tienda?.eslogan && <p>{tienda.eslogan}</p>}
                    {tienda?.direccion && (
                        <Anchor to={`https://www.google.com/maps?q=${encodeURIComponent(tienda.direccion)}`} target="_blank">
                            {tienda.direccion}
                        </Anchor>
                    )}
                    <div className="sidebar-socials">
                        {tienda?.instagram && (
                            <Anchor to={tienda.instagram} target="_blank"><i className='fa fa-instagram'></i></Anchor>
                        )}
                        {tienda?.telefono && (
                            <Anchor to={`tel:${tienda.telefono}`} target="_blank"><i className='fa fa-whatsapp'></i></Anchor>
                        )}
                        {tienda?.facebook && (
                            <Anchor to={tienda.facebook} target="_blank"><i className='fa fa-facebook'></i></Anchor>
                        )}
                    </div>
                </div>

                <ShareWeb />
            </div>
        </aside>
    );
}
